import { useState } from "react";
import { accountService, homeService } from "@miplatform/api";
import { ACCOUNT_TYPE, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useRouter } from "@miplatform/hooks";

export const useCreateCommunityDrawerViewModel = () => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const { navigate } = useRouter();
  const [builders, setBuilders] = useState([]);

  const getBuilders = () => {
    stateManager.run(async () => {
      const response = await accountService.accounts.getAll({
        sort: "name",
        filters: { accountType: ACCOUNT_TYPE.BUILDER },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setBuilders(
          response.data.map(({ name, id }) => ({ label: name, value: id }))
        );
      }
    });
  };

  const createCommunity = (data) => {
    stateManager.run(async () => {
      const response = await homeService.communities.createCommunity({
        data,
        toastMessageConfig: {
          success: { text: `New community ${data.name} was created.` },
        },
      });

      if (response.status === HTTP_STATUSES.CREATED) {
        navigate(`/communities/${response.data.id}`);
      }
    });
  };

  return {
    builders,
    getBuilders,
    isLoading,
    createCommunity,
  };
};
